import { memo } from 'react'

import { Alert, Button } from '@pluggyai/ui'

import './OauthTimeoutError.css'

const OauthTimeoutError = ({ onTryAgain }: { onTryAgain: () => void }) => (
  <div className={'OauthTimeoutError'}>
    <Alert
      type={'error'}
      message={
        'Oops! The authentication process took a bit longer than expected. Please give it another try again'
      }
    />

    <Button primary onClick={onTryAgain}>
      Try again
    </Button>
  </div>
)

export default memo(OauthTimeoutError)
